export enum CustomerType {
  NEW_CUSTOMER_PRICING = 'NEW_CUSTOMER_PRICING',
  EXISTING_CUSTOMER_PRICING = 'EXISTING_CUSTOMER_PRICING',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
}
